import type { DOMProps } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { RefAttributes } from "react";
import type { WithMetadata } from "../../pages";
import type { Quote } from "../QuoteCards/types";
import type { PaymentSummaryProps } from "./PaymentSummary";
import { PaymentSummary } from "./PaymentSummary";
import { QuoteSummary } from "./QuoteSummary";

export type CoverageSummaryElement = HTMLDivElement;

export interface CoverageSummaryProps
  extends DOMProps, RefAttributes<CoverageSummaryElement> {
  quotes: Quote[];
  paymentInfo: PaymentSummaryProps;
  /** Custom class name for setting specific CSS */
  className?: string;
  elementType?: React.ElementType;
}

export const CoverageSummary = ({
  ref,
  ...props
}: WithMetadata<CoverageSummaryProps>) => {
  const { className, quotes, paymentInfo, componentName, ...otherProps } =
    props;

  const classes = classNames("mobius", "mobius-coverage-summary", className);
  const { variant } = otherProps;

  return (
    <div
      ref={ref}
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
      data-testid="coverage-summary"
    >
      <div role="list" className="mobius-coverage-summary__list">
        {quotes.map(quote => (
          <QuoteSummary key={quote.id} quote={quote} />
        ))}
      </div>
      <PaymentSummary {...paymentInfo} />
    </div>
  );
};

CoverageSummary.displayName = "CoverageSummary";
